module.exports = __webpack_public_path__ + "static/product_sans_bold-webfont-f3221d349f515cbcae05da063b5c76e7.woff";